/**
 * 6529.io API
 * This is the API interface description. Brief terminology overview and an authentication example can be found at <a href=\"https://6529.io/about/api\">https://6529.io/about/api</a>.
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { ApiProfileMin } from '../models/ApiProfileMin';
import { ApiProfileProxyAction } from '../models/ApiProfileProxyAction';
import { HttpFile } from '../http/http';

export class ApiProfileProxy {
    'id': string;
    'granted_to': ApiProfileMin;
    'created_at': number;
    'created_by': ApiProfileMin;
    'actions': Array<ApiProfileProxyAction>;

    static readonly discriminator: string | undefined = undefined;

    static readonly mapping: {[index: string]: string} | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": ""
        },
        {
            "name": "granted_to",
            "baseName": "granted_to",
            "type": "ApiProfileMin",
            "format": ""
        },
        {
            "name": "created_at",
            "baseName": "created_at",
            "type": "number",
            "format": ""
        },
        {
            "name": "created_by",
            "baseName": "created_by",
            "type": "ApiProfileMin",
            "format": ""
        },
        {
            "name": "actions",
            "baseName": "actions",
            "type": "Array<ApiProfileProxyAction>",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return ApiProfileProxy.attributeTypeMap;
    }

    public constructor() {
    }
}
